import { effects } from 'redux-saga'

import { selectUser } from '../../modules/signupEdit/actions'

export default function* clearUser() {
  yield effects.put.resolve(selectUser(null))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/clearUser.js